import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router';
import { AddCircleBlue, CustomDelete, FullTable } from 'components';
import { FindSuccess, Images, PermissionList, RolePermission, sortListByKey, useModal } from 'utils';
import { clientActions, httpRequestsOnSuccessActions } from 'store';
import { contactHead, contactBody, ACTION_TYPE, contactNotYet, portalStatusEnums } from './constants';
import { SetContactPassword } from './setContactPassword';
import { AddContact } from '../..';
import { useLocation } from 'react-router-dom';

const DELETE_ACTION_TYPE = 'DELETE_CLIENT_CONTACT';
const GRANT_PORTAL_ACCESS = 'GRANT_PORTAL_ACCESS';

export const ClientContact = ({ }) => {
    const client = useSelector((state) => state.client.clientItemInfo);
    const clientContacts = useSelector((state) => state.client.clientContacts);
    const dispatch = useDispatch();
    const params = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;
    const deleteSuccess = FindSuccess(DELETE_ACTION_TYPE);
    const { open } = useModal();

    useEffect(() => {
            const pushInfo = {
                ...info,
            };
            delete pushInfo.page;
            delete pushInfo.activeTab;
            dispatch(clientActions.getClientsContacts(params.id, { ...pushInfo }));
    }, []);

    useEffect(() => {
        if (deleteSuccess?.length) {
            dispatch(httpRequestsOnSuccessActions.removeSuccess(DELETE_ACTION_TYPE));
        }
    }, [deleteSuccess]);

    const handleClickButton = (item, name) => {
        if (name === 'editContact') {
            open(<AddContact info={item} />);
        } else if (name === 'deleteContact') {
            open(
                <CustomDelete
                    text="Are you sure you want to delete this contact?"
                    info="Delete Contact"
                    handleDel={() => dispatch(clientActions.deleteClientContact(item?.id, client?.id))}
                    actionType={DELETE_ACTION_TYPE}
                    body={
                        <div className="deleting-client-info-box">
                            <img src={Images.client} alt="icon" />
                            <p>{`${item?.firstName} ${item?.lastName ? item?.lastName : ''}`}</p>
                        </div>
                    }
                />
            );
        } else if (name === 'grantAccess') {
            const isReinvite = item?.portalStatus === portalStatusEnums.PENDING_INVITE;
            open(
                <CustomDelete
                    text={isReinvite ? 'Are you sure you want to re-send the portal invitation?' : 'Are you sure you want to invite this contact to the portal?'}
                    info={isReinvite ? 'Re-invite to Portal' : 'Invite to Portal'}
                    color={'blue'}
                    innerText={isReinvite ? 'Re-invite' : 'Invite'}
                    handleDel={() => dispatch(clientActions.grantPortalAccess(client?.id, item?.id))}
                    actionType={GRANT_PORTAL_ACCESS}
                    body={
                        <div className="deleting-client-info-box">
                            <img src={Images.client} alt="icon" />
                            <p>{`${item?.firstName} ${item?.lastName ? item?.lastName : ''}`}</p>
                        </div>
                    }
                />
            );
        } else if (name === 'cancelInvite') {
            open(
                <CustomDelete
                    text="Are you sure you want to cancel the portal invitation for this contact?"
                    info="Cancel Invitation"
                    innerText='Cancel Invitation'
                    handleDel={() => dispatch(clientActions.revokePortalAccess(client?.id, item?.id))}
                    actionType={'REVOKE_PORTAL_ACCESS'}
                    body={
                        <div className="deleting-client-info-box">
                            <img src={Images.client} alt="icon" />
                            <p>{`${item?.firstName} ${item?.lastName ? item?.lastName : ''}`}</p>
                        </div>
                    }
                />
            );
        } else if (name === 'setPassword') {
            open(<SetContactPassword info={item} />);
        } else if (name === 'removeAccess') {
            open(
                <CustomDelete
                    text="Are you sure you want to remove portal access for this contact?"
                    info="Remove Portal Access"
                    innerText='Remove'
                    handleDel={() => dispatch(clientActions.revokePortalAccess(client?.id, item?.id))}
                    actionType={'REVOKE_PORTAL_ACCESS'}
                    body={
                        <div className="deleting-client-info-box">
                            <img src={Images.client} alt="icon" />
                            <p>{`${item?.firstName} ${item?.lastName ? item?.lastName : ''}`}</p>
                        </div>
                    }
                />
            );
        }
    };

    return (
        <div>
            {RolePermission([PermissionList.CLIENT_CONTACT_MANAGE?.code]) && (
                <div className="header-action-btn">
                    <AddCircleBlue text={'Add Contact'} handleClick={() => open(<AddContact />)} />
                </div>
            )}
            <FullTable
                head={contactHead}
                body={contactBody}
                loadingType={ACTION_TYPE}
                list={sortListByKey(clientContacts, 'fullName')}
                // list={clientContacts}
                handleClickButton={handleClickButton}
                notYet={contactNotYet}
                margin={'0'}
            />
        </div>
    );
};
